<template>
  <div class="fields-list">
    <div class="title">
      <div
        v-for="(record, index) in columns"
        :key="index"
        :class="['fl', record.key ]"
      >
        {{ record.title }}
      </div>
    </div>
    <a-form
      ref="form"
      :form="form"
      class="fields-form clearfix"
    >
      <ul v-if="!loading && fields && fields.length">
        <li
          v-for="(record, index) in fields"
          :key="index"
          class="clearfix"
          :class="{'hide': record.disable_flag === '1'}"
        >
          <div
            class="xiaoman fl"
          >
            <!-- xiaoman.prarent -->
            <div
              class="parent"
              :class="{ 'require': record.require === '1' }"
            >
              <span
                class="toggle-btn"
                :style="{ 'opacity': record.ext_info && record.ext_info.length ? 1 : 0 }"
                @click="handleToggle(record, index)"
              >
                <i
                  class="iconfont"
                  :class="{ 'iconicon-test9': !record.showChild, 'iconicon-test11': record.showChild }"
                />
              </span>
              <a-input
                :default-value="record.name"
                :disabled="true"
              />
            </div>

            <!-- xiaoman.children -->
            <div
              v-show="record.showChild"
              class="children"
            >
              <a-input
                v-for="one in record.ext_info"
                :key="one.id"
                :default-value="one.val"
                :disabled="true"
              />
            </div>
          </div>
          <div
            class="westartrack fl"
          >
            <!-- westartrack.prarent -->
            <a-form-item class="westartrack-prarent">
              <a-select
                v-decorator="[`wefieldkey_${index}`, {
                  rules: [{
                    required: record.require === '1', message: '小满必填字段必须设置对应星轨字段'
                  }],
                  initialValue: record.wefieldkey
                }]"
                :allow-clear="true"
                :show-search="true"
                :filter-option="filterOption"
                :get-popup-container="
                  triggerNode => {
                    return triggerNode.parentNode || document.body;
                  }
                "
                dropdown-class-name="wefieldkey-select"
                placeholder="请选择"
                @dropdownVisibleChange="dropdownVisibleChangeParent($event, index, record)"
                @change="handleChangeFieldtype($event, record, index)"
              >
                <a-select-option
                  v-if="selectOptionsEmpty"
                  key="empty"
                  class="empty"
                >
                  <i class="iconfont iconicon-test38" />
                  暂无选项
                </a-select-option>
                <a-select-opt-group
                  v-for="modules in selectOptions"
                  :key="modules.fieldkey"
                  :class="{ hide: setShowSelectGroup(modules) }"
                >
                  <span
                    v-if="modules.fieldname"
                    slot="label"
                  >{{ modules.fieldname }}</span>
                  <a-select-option
                    v-for="field in modules.child"
                    :key="field.fieldkey"
                    :value="field.fieldkey"
                    :disabled="field.chooseed || field.del"
                    :class="{ hide: field.chooseed || field.del }"
                  >
                    {{ field.fieldname }}<span v-if="field.fieldtype_desc">[{{ field.fieldtype_desc }}]</span>
                  </a-select-option>
                </a-select-opt-group>
              </a-select>
            </a-form-item>
            <!-- westartrack.children -->
            <a-form-item
              v-show="record.showChild"
            >
              <field-item
                v-for="(item, i) in record.assoc"
                :key="item.xiaomanoptionkey"
                :data="item"
                :row="record"
                :all-selected="allSelected"
                class="field-item"
                @change="handleChangeChild($event, index, i)"
              />
            </a-form-item>
          </div>
        </li>
      </ul>
    </a-form>
    <!-- 字段列表为空 -->
    <div
      v-if="!loading && fields && !fields.length"
      class="empty-box"
    >
      <i class="iconfont iconicon-test38 logo" />
      <p
        v-if="isSyncfield"
        class="placeholder"
      >
        没有获取到小满的字段配置，请查阅 <router-link
          :to="{ name: 'XiaomanBaseConfig' }"
          class="routelink fs-blue"
        >
          基础配置
        </router-link> ，确保正确配置了小满主帐号信息
      </p>
      <p
        v-else
        class="placeholder"
      >
        暂无数据
      </p>
    </div>
    <a-spin
      v-if="loading"
      class="fields-loading"
    >
      <div class="spin-content">
        正在获取小满字段，请稍后…
      </div>
    </a-spin>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import FieldItem from './Item'
import { cloneDeep } from 'lodash'

export default {
  components: {
    FieldItem
  },

  props: {
    data: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    isSyncfield: {
      type: Boolean,
      default: false
    }
  },

  data () {
    let fields = this.data
    return {
      fields,
      form: this.$form.createForm(this),
      selectOptionsEmpty: false
    }
  },

  computed: {
    ...mapState('config/xiaoman/setFields', ['columns', 'allSelectOptions', 'count', 'isBtnDisable']),

    allSelectOptionsArr () {
      let arr = []
      for (let key in this.allSelectOptions) {
        let { child = [] } = this.allSelectOptions[key]
        for (let i = 0; i < child.length; i++) {
          let item = child[i]
          if (!arr.includes(item)) {
            arr.push(item)
          }
        }
      }
      return arr
    },

    selectOptions () {
      let obj = {}
      for (let i = 0; i < this.fields.length; i++) {
        let { field_type: xiaomanFieldtype, wefieldkey } = this.data[i]

        obj = this.setFieldOption(xiaomanFieldtype, wefieldkey)
      }
      return obj
    },

    allSelected () {
      if (!this.fields || !this.fields.length) return

      let obj = {}
      this.fields.forEach((field, index) => {
        if (field && field.wefieldkey && field.disable_flag === '0') {
          obj[field.wefieldkey] = []
          field.assoc.forEach((item, j) => {
            if (item.weoptionkey && !obj[field.wefieldkey].includes(item.weoptionkey)) {
              obj[field.wefieldkey].push(item.weoptionkey)
            }
          })
        }
      })
      return obj
    }
  },

  watch: {
    data: {
      handler (val) {
        if (!val && !val.length) return

        this.fields = this.resetDatas(val)
      },
      deep: true,
      immediate: true
    },

    allSelectOptionsArr: {
      handler (val) {
        if (!val && !val.length) return

        this.fields = this.resetDatas(this.fields)
      },
      deep: true,
      immediate: true
    },

    allSelected (val) {
      if (!this.fields || !this.fields) return

      let { allSelected } = this

      this.fields.forEach((field = {}) => {
        let { wefieldkey } = field
        if (wefieldkey && allSelected[wefieldkey] && field.options) {
          for (let index = 0; index < field.options.length; index++) {
            field.options[index].disabled = false
            field.options[index].chooseed = false
            for (let k = 0; k < allSelected[wefieldkey].length; k++) {
              if (field.options[index].id === allSelected[wefieldkey][k]) {
                field.options[index].disabled = true
                field.options[index].chooseed = true
              }
            }
          }
        }
      })
      this.$forceUpdate()
    }
  },

  methods: {
    ...mapActions(['addClick', 'removeClick']),
    ...mapActions('config/xiaoman', ['fetchXiaomanBaseInfo']),
    ...mapActions('config/xiaoman/setFields', ['fetchAllOptions', 'setXiaomanFieldAssoc']),
    ...mapMutations('config/xiaoman/setFields', ['SET_COUNT', 'SET_SAVE_BTN_DISABLED']),

    resetDatas (value) {
      let data = cloneDeep(value)
      if (!data) return

      let filters = data.filter(item => item.disable_flag === '0')

      let arr = filters.map((field = {}) => {
        let { wefieldkey = undefined } = field
        let { allSelectOptionsArr = [] } = this

        field.currField = {}
        field.options = []

        // 如果小满字段有字集，默认展开
        if (field.ext_info && field.ext_info.length) {
          field.showChild = field.showChild !== false
        }

        // 如果父级有选择值
        if (wefieldkey && allSelectOptionsArr.length) {
          let currField = allSelectOptionsArr.find(option => option.fieldkey === wefieldkey)

          field.currField = currField || {}
          field.options = (currField && currField.options) || []

          // 如果返回的wefieldkey有值，但是下拉列表里没有选择，已被提交信息配置删除，设置为空
          let index = allSelectOptionsArr.findIndex(item => item.fieldkey === wefieldkey)
          if (index === -1) {
            field.wefieldkey = undefined
            if (field.showChild && field.assoc && field.assoc.length) {
              field.assoc.forEach(ass => {
                ass.weoptionkey = ''
              })
            }
          }
        }

        return field
      })
      return arr || []
    },

    // 设置每个字段的下拉选项
    setFieldOption (xiaomanFieldtype, wefieldkey) {
      let allOptions = this.allSelectOptions
      for (let key in allOptions) {
        let modules = allOptions[key]
        let { child } = modules
        for (let len = child.length, i = len - 1; i >= 0; i--) {
          let item = child[i]

          item.chooseed = false

          if (item.fieldkey === wefieldkey) {
            item.chooseed = true
          }
        }
      }
      return allOptions
    },

    // 判断小满和星轨可选字段的对应类型
    isDeleteFieldOption (item, xiaomanFieldtype) {
      let { id, fieldtype } = item
      let isDel = false
      switch (xiaomanFieldtype) {
        // 文本
        case '0':
        case '1':
        case '2':
          if (fieldtype === 'file') {
            isDel = true
          }
          // 小满的社交平台字段，只能对应星轨的text类型
          if (id === 'customers.contact' && fieldtype !== 'text') {
            isDel = true
          }
          break
        // 下拉
        case '3':
          if (fieldtype !== 'select' && fieldtype.indexOf('radio') === -1) {
            isDel = true
          }
          // 小满的国家地区字段，只能对应星轨的area类型
          if (id === 'country' && fieldtype !== 'area') {
            isDel = true
          }
          break
        // 日期
        case '4':
        case '10':
          if (fieldtype !== 'datetime') {
            isDel = true
          }
          break
        // 数字
        case '5':
          if (fieldtype !== 'number') {
            isDel = true
          }
          break
        // 图片
        case '6':
          if (fieldtype !== 'file' && fieldtype !== 'editor') {
            isDel = true
          }
          break
        // 下拉多选
        case '7':
          if (fieldtype !== 'select' && fieldtype.indexOf('radio') === -1 && fieldtype !== 'checkbox' && fieldtype !== 'select_tree') {
            isDel = true
          }
          break
        // 附件
        case '8':
          if (fieldtype !== 'file') {
            isDel = true
          }
          break
      }
      return isDel
    },

    /* 小满字段点击折叠 */
    handleToggle (record, index) {
      if (record.ext_info && record.ext_info.length) {
        record.showChild = !record.showChild
        this.fields.splice(index, 1, record)
      }
    },

    /* 选择星轨字段的父级 */
    handleChangeFieldtype (value, record, index) {
      // 设置表单操作的动作数
      let count = this.count + 1
      this.SET_COUNT(count)

      if (this.allSelected[record.wefieldkey]) {
        delete this.allSelected[record.wefieldkey]
      }
      // 清空子集的选择结果
      record.assoc = record.assoc.map((item, i) => {
        item.weoptionkey = ''
        return item
      })

      // 如果点击了清空
      if (!value) {
        record.wefieldkey = undefined
        record.currField = {}
        record.options = []
        this.setParentOptionChooseed(record)
        this.fields.splice(index, 1, record)
        return
      }

      // 设置父级的选择结果
      record.wefieldkey = value

      // 设置子集的类型，下拉等属性
      let currField = this.allSelectOptionsArr.find(field => field.fieldkey === value)
      /* record.currField = currField
      record.options = currField.options */
      this.$set(record, 'currField', currField || {})
      this.$set(record, 'options', currField.options || [])

      this.fields.splice(index, 1, record)
      this.$forceUpdate()
    },

    /* 将每一行的下拉框，选择过的值都标记 true */
    setParentOptionChooseed (row) {
      let { allSelected } = this
      let { field_type: xiaomanFieldtype } = row

      for (let key in this.selectOptions) {
        let modules = this.selectOptions[key]
        modules.child.forEach((item, i) => {
          item.chooseed = false
          item.del = false

          if (Object.keys(allSelected).includes(item.fieldkey)) {
            item.chooseed = true
          }
          // 如果已小满类型和星轨的类型不对应，删除
          let isDel = this.isDeleteFieldOption(item, xiaomanFieldtype)
          if (isDel) {
            item.del = true
          }
        })
      }

      this.$forceUpdate()
    },

    setShowSelectGroup (modules = {}) {
      let len = 0
      let res = false
      if (modules.child && this.$toType(modules.child) === 'array') {
        len = modules.child && modules.child.filter(item => item.chooseed || item.del).length
        res = len === modules.child.length
      }

      return res
    },

    /* 下拉选择框展开事件
     * value: Bollean
     */
    dropdownVisibleChangeParent (value, index, row) {
      if (value) {
        this.setParentOptionChooseed(row)
        this.setSelectOptionsEmpty()
      }
    },

    /* 可供选择的下拉框内容是否为空 */
    setSelectOptionsEmpty () {
      let arr = []
      for (let key in this.selectOptions) {
        let { child = [] } = this.allSelectOptions[key]
        for (let i = 0; i < child.length; i++) {
          let item = child[i]
          if (!arr.includes(item)) {
            arr.push(item)
          }
        }
      }
      let options = arr.filter(option => !option.del)
      let filters = options.filter(option => !option.chooseed)
      this.selectOptionsEmpty = filters.length === 0
    },

    /* 选择星轨字段的字集 */
    handleChangeChild (value, item, index, i) {
      let count = this.count + 1
      this.SET_COUNT(count)

      if (this.fields[index].assoc && this.fields[index].assoc[i]) {
        this.fields[index].assoc[i].weoptionkey = value
      }

      this.$forceUpdate()
    },

    filterOption (input, option = {}) {
      let { componentOptions = {} } = option
      let { children = [] } = componentOptions
      let { text = '' } = children[0]
      return text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },

    handleSubmit () {
      if (this.isBtnDisable) return

      this.form.validateFields((err, values) => {
        if (!err) {
          this.SET_SAVE_BTN_DISABLED(true)
          this.submitConfirm()
        }
      })
    },

    async submitConfirm () {
      let params = this.fields.map((field = {}) => {
        let { id, wefieldkey, assoc = [] } = field
        let obj = {}
        obj.id = id
        obj.wefieldkey = wefieldkey
        obj.assoc = assoc.map((item = {}) => {
          let { weoptionkey, xiaomanoptionkey } = item
          return {
            weoptionkey,
            xiaomanoptionkey
          }
        })
        return obj
      })

      let chain = await this.setXiaomanFieldAssoc(params)
      chain
        .onSuccess(res => {
          this.fetchXiaomanBaseInfo({
            showLoading: false
          })
          this.SET_SAVE_BTN_DISABLED(false)
          this.SET_COUNT(0)
        })
    }
  }
}
</script>

<style scoped lang="scss">
.fields-list {
  padding: 24px 0;
}
.title {
  height: 48px;
  line-height: 48px;
  background: #F5F6F7;
  border: none;
  border-radius: 4px;
  .xiaoman, .westartrack {
    padding: 0 16px;
    font-weight: bold;
  }
}
.xiaoman {
  width: 480px;
}
.westartrack {
  width: 560px;
}
li {
  padding: 8px 0;
  border-bottom: solid 1px #EBEBEB;
  .xiaoman {
    .ant-input {
      background-color: #F5F5F5;
      border-color: #d6d6d6;
    }
    .parent.require:after{
      content: '*';
      margin-left: 4px;
      color: #F57676;
    }
    .children {
      margin-left: 75px;
      .ant-input {
        width: 264px;
        margin: 8px 0;
      }
    }
  }
  .westartrack {
    .westartrack-prarent ::v-deep {
      margin-bottom: 0;
      .ant-form-explain {
        display: inline-block;
        margin-left: 8px;
      }
    }
    .field-item {
      width: 264px;
      margin: 8px 0 8px 56px;
    }
  }
  .fl {
    padding: 0 16px;
  }
  .toggle-btn {
    float: left;
    width: 20px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    color: #d6d6d6;
    cursor: pointer;
  }
}

.empty-box {
  text-align: center;
  .logo {
    display: block;
    margin: 40px auto 8px;
    font-size: 24px;
    color: #d6d6d6;
  }
  .placeholder {
    margin-bottom: 16px;
    color: $gray3;
  }
}

.fields-loading ::v-deep {
  display: block;
  text-align: center;
  .ant-spin-blur {
    opacity: 1;
  }
  .spin-content {
    margin-top: 68px;
    color: #333;
  }
}

::v-deep .wefieldkey-select {
  .hide {
    display: none;
  }
  .empty {
    text-align: center;
    color: #b3b3b3;
    .iconfont {
      display: block;
      margin: 10px 0 8px;
      text-align: center;
      color: #D6D6D6;
      font-size: 24px;
    }
    &.ant-select-dropdown-menu-item,
    &.ant-select-dropdown-menu-item:hover {
      background: none;
    }
    .ant-select-selected-icon {
      display: none;
    }
  }
  .ant-select-dropdown-menu-item-disabled:hover {
    background: none;
  }
}
</style>
